const availableProfiles = ['PROFESSOR', 'ADMINISTRADOR', 'COORDENADOR']
const newScriptAvaliableProfiles = ['ADMINISTRADOR', 'COORDENADOR']
const newScriptAvaliableSchools = [
  'bc06e606-45ae-4999-8add-d9d35650d6b4',
  '429d831d-ce59-4a1b-b3f7-6f63f6515a33',
  '30d25e02-1d42-4840-80e0-915f10d7d4a5',
  '03fcabbd-39f6-417c-b75f-939b959323a3',
  '3cc25e63-1403-4bfa-843d-330a372f5495',
  '3dc4eef4-7af4-4cad-8c59-00d203767b1b',
  '87909a2c-7ec1-4103-bf12-83467e69fd9a',
  '6f7d890b-ebb7-4efc-8e23-3b5de5770885'
]

function initChatbot(profile: string, schoolId: string): void {
  const shouldReturnNewScript =
    newScriptAvaliableProfiles.includes(profile) &&
    newScriptAvaliableSchools.includes(schoolId)

  if (shouldReturnNewScript) {
    require('../scripts/newZoho')
    return
  }

  if (availableProfiles.includes(profile)) {
    require('../scripts/zoho')
  }
}

function toggleChatbot(): void {
  const isWindowOpen =
    window?.$zoho?.salesiq?.values?.floatwindowvisible === 'show'

  if (isWindowOpen) {
    window.$zoho.salesiq.floatwindow.close()
    return
  }

  window?.$zoho?.salesiq?.floatwindow?.open()
}

declare global {
  interface Window {
    $zoho: any
  }
}

function removeChatbot(): void {
  window.$zoho = undefined

  const zoho = document.getElementById('zsiqscript')

  zoho?.remove()
}

function hideFloatButton(): void {
  if (!window?.$zoho?.salesiq?.floatbutton?.visible) return
  window.$zoho.salesiq.floatbutton.visible('hide')
}

function showFloatButton(): void {
  if (!window?.$zoho?.salesiq?.floatbutton?.visible) return
  window.$zoho.salesiq.floatbutton.visible('show')
}

export {
  initChatbot,
  removeChatbot,
  toggleChatbot,
  hideFloatButton,
  showFloatButton,
  availableProfiles
}
